<!-- 
设置面包屑的方法(优先级有高到低）：
1、路由meta设置: breadcrumbList
   import { globalStateActions } from '@/micro-app'
2、接受基座页面通知：GTR_EVENT_KEYS.useBreadcrumb 
   import eventBus from '@/plugins/evnt-bus'
3、接受子应用通知：onGlobalStateChange

面包屑格式
[
  {title:'标题1',path: '/path1'},
  {title:'标题2',path: '/path2'},
]
 -->
<template>
  <pb-breadcrumb
    v-if="!hiddenBreadCrumb && breadcrumbList.length > 0 && gtrBreadcrumbShow"
    class="gtr-layout-app_breadcrumb"
  >
    <pb-breadcrumb-item
      v-for="(item, ind) in breadcrumbList"
      :key="`${item.title}-${ind}`"
      :to="{ path: item.path }"
    >
      <span :class="[ind === breadcrumbList.length - 1 ? 'current' : '']">{{ item.title }}</span>
    </pb-breadcrumb-item>
  </pb-breadcrumb>
</template>

<script>
import { computed, ref } from 'vue';
import { globalStateActions, matchMicroAppRoute } from '@/micro-app';
import eventBus, { GTR_EVENT_KEYS } from '@/plugins/evnt-bus';
import { useRoute } from '@/utils';
function useBreadcrumb(subBreadcrumb) {
  const breadcrumbList = computed(() => {
    const route = useRoute();
    if (route.meta?.breadcrumbList?.length > 0) {
      return route.meta?.breadcrumbList;
    }
    // 子系统透出的面包屑
    if (subBreadcrumb?.value && subBreadcrumb?.value.length > 0) {
      return subBreadcrumb?.value.map((item) => {
        const path = item.path;
        const matchApp = matchMicroAppRoute(path);
        return {
          ...item,
          path: matchApp ? matchApp.prefix + path : path,
        };
      });
    }
    return [];
  });
  return {
    breadcrumbList,
  };
}
function useSubBreadcrumb() {
  // 基座面包屑
  const subBreadcrumb = ref([]);
  const gtrBreadcrumbShow = ref(true);
  globalStateActions.onGlobalStateChange((state) => {
    if (!Array.isArray(state.subBreadcrumb)) {
      console.error(`type error -- subBreadcrumb -- isArray, got ${state.subBreadcrumb}`);
      return;
    }
    subBreadcrumb.value = state.subBreadcrumb;
    gtrBreadcrumbShow.value = !!state.gtrBreadcrumbShow;
  });
  eventBus.$on(GTR_EVENT_KEYS.useBreadcrumb, (state) => {
    if (!Array.isArray(state.subBreadcrumb)) {
      console.error(`type error -- subBreadcrumb -- isArray, got ${state.subBreadcrumb}`);
      return;
    }
    subBreadcrumb.value = state.subBreadcrumb;
    gtrBreadcrumbShow.value = !!state.gtrBreadcrumbShow;
  });
  return {
    subBreadcrumb,
    gtrBreadcrumbShow,
  };
}
export default {
  name: 'Breadcrumb',
  setup() {
    const { subBreadcrumb, gtrBreadcrumbShow } = useSubBreadcrumb();
    const { breadcrumbList } = useBreadcrumb(subBreadcrumb);
    const hiddenBreadCrumb = ref(false);
    return {
      breadcrumbList,
      gtrBreadcrumbShow,
      hiddenBreadCrumb: hiddenBreadCrumb,
    };
  },
  watch: {
    '$route.meta': {
      immediate: true,
      handler(n, o) {
        if (n.breadcrumbList && n.breadcrumbList.length > 0) {
          this.hiddenBreadCrumb = false;
          this.gtrBreadcrumbShow = true;
          return;
        }
        if (n?.hiddenBreadCrumb !== undefined) {
          this.hiddenBreadCrumb = n?.hiddenBreadCrumb;
        } else {
          this.hiddenBreadCrumb = false;
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.gtr-layout-app_breadcrumb {
  margin: 10px 20px;
  .current {
    color: #030405;
    cursor: default;
  }
}
</style>
